import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useMe } from "../../../../swr";
import { AppRoutes } from "../../../../common/routes/app_routes";

// Steps a logged-in user is still allowed to be on — i.e. the post-OTP part of
// the wizard. Anything earlier (credentials/partner-type/business-details/
// verify-email) is for unauthenticated users only.
const POST_AUTH_WIZARD_STEPS: string[] = [
  AppRoutes.CREATE_ACCOUNT_DOCUMENTS,
  AppRoutes.CREATE_ACCOUNT_BANKING_DETAILS,
  AppRoutes.CREATE_ACCOUNT_APPROVAL_PENDING,
];

export function CreateAccountPage() {
  const { user } = useMe();
  const location = useLocation();

  if (user && !POST_AUTH_WIZARD_STEPS.includes(location.pathname)) {
    return <Navigate to={AppRoutes.INDEX} replace />;
  }

  return <Outlet />;
}

export default CreateAccountPage;
